import getOr from "lodash/fp/getOr";
import { validCountries } from "../global/validCountries";
import { nFormatter } from "../utils/utils";

const closeImg = require("../assets/images/close-blue.svg");
const flagImg = require("../assets/images/flag.svg");

export class MarketRanking {
  constructor(Code, ISO2, ISO3, Name, Agreement, MarketSize, Transportation, TransportationText, AverageGDPGrowth, ExchangeRatesInflation, DifficultyOfRegulation, TradingAcrossBorder, EaseDoingBusiness, Ranking, Flag, Score, CorruptionLevel, DutiesTaxes, PurchasingPowerIndex, GDPPerCapita) {
    this.Code = Code;
    this.ISO2 = ISO2;
    this.ISO3 = ISO3;
    this.Name = Name;
    this.Agreement = Agreement;
    this.MarketSize = MarketSize;
    this.Transportation = Transportation;
    this.TransportationText = TransportationText;
    this.AverageGDPGrowth = AverageGDPGrowth;
    this.ExchangeRatesInflation = ExchangeRatesInflation;
    this.DifficultyOfRegulation = DifficultyOfRegulation;
    this.TradingAcrossBorder = TradingAcrossBorder;
    this.EaseDoingBusiness = EaseDoingBusiness;
    this.Ranking = Ranking;
    this.Flag = Flag;
    this.Score = Score;
    this.CorruptionLevel = CorruptionLevel;
    this.DutiesTaxes = DutiesTaxes;
    this.PurchasingPowerIndex = PurchasingPowerIndex;
    this.GDPPerCapita = GDPPerCapita;
  }
  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      return new MarketRanking(
        input.Code,
        input.ISO2,
        input.ISO3,
        input.Name,
        input.Agreement,
        input.MarketSize,
        getOr([], 'Transportation')(input),
        getOr('', 'TransportationText')(input),
        input.AverageGDPGrowth,
        input.ExchangeRatesInflation,
        {
          CostToImportBorderCompliance: getOr('', 'DifficultyOfRegulation.CostToImportBorderCompliance')(input),
          TimeToImportBorderCompliance: getOr('', 'DifficultyOfRegulation.TimeToImportBorderCompliance')(input),
          CostToImportDocumenttaryCompliance: getOr('', 'DifficultyOfRegulation.CostToImportDocumenttaryCompliance')(input),
          TimeToImportDocumenttaryCompliance: getOr('', 'DifficultyOfRegulation.TimeToImportDocumenttaryCompliance')(input)
        },
        input.TradingAcrossBorder,
        input.EaseDoingBusiness,
        input.Ranking,
        input.Flag,
        input.Score,
        getOr('', 'CorruptionLevel')(input),
        getOr('', 'DutiesTaxes')(input),
        getOr('', 'PurchasingPowerIndex')(input),
        getOr('', 'GDPPerCapita')(input)
      );
    }
    return new MarketRanking();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => MarketRanking.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [MarketRanking.fromApiObject(input)];
    }
    return [];
  }

  genHtml(index) {
    let transportation = '';
    this.Transportation.forEach(element => {
      transportation += `<div class="${element}"></div>`;
    });
    if (transportation) {
      transportation = `
      <div class="type">
        ${transportation}
      </div>
      `
    }
    let country = '';
    if (this.ISO2) {
      country += `
        <img src="${this.Flag || flagImg}" alt="flag" />
        <div title="${this.Name}" class="title">${this.Name}</div>
        <div class="score">${this.Score}/100</div>
      `;
    } else {
      country += MarketRanking.genCountrySelect(index);
    }
    return `
      <div class="item ${this.ISO2 ? this.ISO2 : 'select'}">
        <div data-index="${index !== undefined ? index : ''}" class="remove-box">
          <img alt='close' src="${closeImg}"/>
          Remove
        </div>
        <div class="border-box">
          <div class="country">
            ${country}
          </div>
          <div title="${!this.ISO2 ? '' : parseNumber(this.MarketSize || null, 2, '', '', '$')}">${!this.ISO2 ? '' : parseNumber(this.MarketSize || null, 2, '<span class="miss">Updating</span>', '', '$', true)}</div>
          <div class="transportation">
            ${!this.ISO2 ? '' : transportation}
            <div class="distance">${!this.ISO2 ? '' : this.TransportationText || '<span class="miss">Updating</span>'}</div>
          </div>
          <div class="agreement">${!this.ISO2 ? '' : typeof this.Agreement === 'boolean' ? (this.Agreement ? "Yes" : "No") : ''}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.AverageGDPGrowth, 2, '', '%')}</div>
          <div title="${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.CostToImportBorderCompliance, 2, '', '', '$')}">${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.CostToImportBorderCompliance, 2, '<span class="miss">Updating</span>', '', '$', true)}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.TimeToImportBorderCompliance, 2, '<span class="miss">Updating</span>', 'h')}</div>
          <div title="${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.CostToImportDocumenttaryCompliance, 2, '', '', "$")}">${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.CostToImportDocumenttaryCompliance, 2, '<span class="miss">Updating</span>', '', "$", true)}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.DifficultyOfRegulation.TimeToImportDocumenttaryCompliance, 2, '<span class="miss">Updating</span>', 'h')}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.CorruptionLevel, 2, '')}</div>
          <div class="duty-tax">${!this.ISO2 ? '' : parseNumber(this.DutiesTaxes, 2, '<span class="miss">Updating</span>')}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.ExchangeRatesInflation, 2, '', '%')}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.PurchasingPowerIndex, 2, '<span class="miss">Updating</span>')}</div>
          <div title="${!this.ISO2 ? '' : parseNumber(this.GDPPerCapita, 2, '', '', '$')}">${!this.ISO2 ? '' : parseNumber(this.GDPPerCapita, 2, '<span class="miss">Updating</span>', '', '$', true)}</div>
          <div>${!this.ISO2 ? '' : parseNumber(this.EaseDoingBusiness, 2, '', '', '#')}</div>
        </div>
        <div class="compare">
          <label>
            <input type="checkbox" name="compare" value="${this.ISO2}" />
            Compare
          </label>
        </div>
      </div>
    `
  }

  static genCountrySelect = (index) => {
    let element = `<select data-index="${index}"><option value=''>Choose country</option>`
    validCountries.data.forEach(item => {
      if (!window.marketRankCompare.includes(item.iso2)) {
        element += `<option data-extra-search='${JSON.stringify(item)}' value="${item.iso2}">${item.name}</option>`;
      }
    });
    element += `</select>`;
    return element;
  }

  static getData = (arr, moreArr, code) => {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (item.ISO2 === code) {
        return item;
      }
    }
    for (let i = 0; i < moreArr.length; i++) {
      const item = moreArr[i];
      if (item.ISO2 === code) {
        return item;
      }
    }
  }
}

function parseNumber(data, decimal = 2, defaultData = '', suffFix = '', prefix = '', isNFormatter = false) {
  switch (typeof data) {
    case 'number':
      return !isNFormatter ? prefix + (data.toFixed(decimal) * 1) + suffFix : nFormatter(data, decimal, prefix) + suffFix;
    case 'string':
      if (data && !isNaN(data)) {
        return !isNFormatter ? prefix + ((data * 1).toFixed(decimal) * 1) + suffFix : nFormatter(data * 1, decimal, prefix) + suffFix;
      }
      return defaultData;
    default:
      return defaultData;
  }
}